<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear / Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_discapacidad === null ? "Crear" : "Editar" }} Discapacidad
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="editedItem.descripcion"
                label="Descripción"
                outlined
                dense
                hide-details
                rows="3"
                auto-grow
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Discapacidad</v-card-title>

        <v-card-text>
          ¿Está seguro de que desea eliminar la discapacidad llamada
          "{{ editedItem.nombre }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Discapacidad
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <!-- Columna descripción (bonita y corta) -->
          <template v-slot:[`item.descripcion`]="{ item }">
            <span :title="item.descripcion">
              {{ truncate(item.descripcion, 120) }}
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      {
        text: "Discapacidad",
        value: "nombre",
        align: "center",
        width: "30%"
      },
      {
        text: "Descripción",
        value: "descripcion",
        align: "left",
        width: "60%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],

    editedItem: {
      id_discapacidad: null,
      nombre: "",
      descripcion: ""
    },
    defaultEditedItem: {
      id_discapacidad: null,
      nombre: "",
      descripcion: ""
    }
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    truncate(text, max) {
      if (!text) return "";
      const s = String(text);
      return s.length > max ? s.substring(0, max) + "..." : s;
    },

    getItems() {
      this.loading = true;
      axios
        .get("/Catalogos/ListarDiscapacidades")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al cargar las discapacidades.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      // Nombre
      if (
        this.editedItem.nombre == null ||
        this.editedItem.nombre.length === 0 ||
        this.editedItem.nombre.length > 256
      ) {
        this.$refs.alert.setMessage("", "Debe de ingresar un Nombre entre 1 y 256 caracteres");
        this.$refs.alert.open();
        return;
      }

      // Descripción
      if (
        this.editedItem.descripcion == null ||
        this.editedItem.descripcion.length === 0 ||
        this.editedItem.descripcion.length > 512
      ) {
        this.$refs.alert.setMessage("", "Debe de ingresar una Descripción entre 1 y 512 caracteres");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      const isCreate = this.editedItem.id_discapacidad === null;

      axios({
        method: isCreate ? "POST" : "PUT",
        url: isCreate
          ? "/Catalogos/CrearDiscapacidad"
          : `/Catalogos/EditarDiscapacidad/${this.editedItem.id_discapacidad}`,
        data: {
          nombre: this.editedItem.nombre,
          descripcion: this.editedItem.descripcion
        }
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((error) => {
          if (error?.response?.status === 409) {
            this.$refs.alert.setMessage("", "Ya existe una Discapacidad con el mismo Nombre.");
            this.$refs.alert.open();
            return;
          }

          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al guardar la discapacidad.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      if (this.editedItem.id_discapacidad == null) return;

      this.loadingDelete = true;
      axios
        .delete(`/Catalogos/EliminarDiscapacidad/${this.editedItem.id_discapacidad}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al eliminar la discapacidad.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
};
</script>
